export function color_map_score(score){
  let color
  
    if(score <=1)
    {color = 'rgba(240, 59, 10, 0.6)'}
    else if(score <=2)
    {color ='rgba(235, 200, 26, 0.6)'}
    else if(score <=3)
    {color = 'rgba(54, 162, 235, 0.6)'}
    else if(score <=4)
    {color = 'rgba(134, 230, 106, 0.6)'}
    else if(score <=5)
    {color = 'rgba(65, 138, 43, 0.6)'}
    else if (score >5)
    {color = 'rgba(65, 138, 43, 0.6)'}

    return color
  }